module.exports = __webpack_public_path__ + "img/img-97.c086ebb7.png";